import React from 'react';

export default function ConfirmDialog({ open, title, description, onConfirm, onCancel, confirmLabel = 'Confirmar' }) {
  if (!open) return null;

  return (
    <div className="admin-modal-overlay">
      <div className="admin-modal">
        <h3 style={{ marginBottom: 8 }}>{title}</h3>
        <p style={{ color: '#B8B8C5', marginBottom: 16 }}>{description}</p>
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
          <button className="admin-button secondary" onClick={onCancel}>Cancelar</button>
          <button className="admin-button" onClick={onConfirm}>{confirmLabel}</button>
        </div>
      </div>
    </div>
  );
}
